import { configureStore } from '@reduxjs/toolkit';
import authReducer from 'features/auth/slices/authSlice';
import orderReducer from 'features/orders/slices/orderSlice';
import aoiReducer from 'features/explore/slices/aoiSlice';
import mapReducer from 'features/explore/slices/mapSlice';
import catalogReducer from 'features/explore/slices/catalogSlice';
import taskingReducer from 'features/explore/slices/taskingSlice';
import dialogReducer from 'features/explore/slices/dialogSlice';
import imintReducer from 'features/imint/slices/imintSlice';
import notificationReducer from './notificationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    orders: orderReducer,
    aoi: aoiReducer,
    map: mapReducer,
    catalog: catalogReducer,
    tasking: taskingReducer,
    dialog: dialogReducer,
    imint: imintReducer,
    notification: notificationReducer,
  },
});

export default store;
